<template>
  <label :for="htmlFor" class="smardie-field-label">
    <slot />
  </label>
</template>

<script>
export default {
  name: 'FieldLabel',
  props: {
    htmlFor: {
      type: String,
      default: ''
    }
  }
}
</script>
